import React from 'react';
import { LayoutCard } from './list-catalogs.styles';
import { ListCatalogsProps } from './types';
import { PaginationLayout } from '@shared/ui/pagination-layout/pagination-layout';
import { getQueryError } from '@shared/lib/utils/get-query-error/get-query-error';
import { useCatalogsListSharedQuery } from '@entities/catalog/libs/hooks/use-catalogs-list-shared-query/use-catalogs-list-shared-query';
import { CardCatalog } from '@entities/catalog/ui/card-catalog/card-catalog';
import { EditCatalog } from '@features/catalog/mutate-catalog/ui/edit-catalog';
import { CreateProduct } from '@features/product/mutate-product/ui/create-product';
import { NetworkStateNew } from '@shared/ui/network-state-new/network-state-new';

export const ListCatalogs: React.FC<ListCatalogsProps> = ({ catalogsListParameters, setCatalogsListParameters }) => {
    const [, getCatalogsListResult] = useCatalogsListSharedQuery(catalogsListParameters);
    const isLoading =
        getCatalogsListResult.isLoading || getCatalogsListResult.isFetching || getCatalogsListResult.isUninitialized;

    return (
        <PaginationLayout
            listLength={getCatalogsListResult.data?.total || 0}
            isLoading={isLoading}
            parameters={catalogsListParameters}
            setParameters={setCatalogsListParameters}>
            <LayoutCard>
                <NetworkStateNew
                    isLoading={isLoading}
                    isError={getCatalogsListResult.isError}
                    isInitialized={Boolean(getCatalogsListResult.data)}
                    isFiltered={Boolean(getCatalogsListResult.data?.search)}
                    hasData={Boolean(getCatalogsListResult.data?.items.length)}
                    errorProps={{
                        title: 'Ошибка загрузки каталогов',
                        description: getQueryError(getCatalogsListResult)?.message,
                    }}
                    emptyProps={{
                        title: 'Каталоги отсутствуют',
                    }}
                    emptyFilteredProps={{
                        title: 'Каталоги не найдены',
                    }}
                    updateLoaderProps={{
                        style: { left: 20, right: 20 },
                    }}>
                    {getCatalogsListResult.data?.items.map((catalog) => (
                        <CardCatalog key={catalog.id} catalog={catalog}>
                            <EditCatalog catalog={catalog} />
                            <CreateProduct
                                type='icon'
                                additionalProductInfo={{
                                    catalogs: [
                                        {
                                            label: catalog.name,
                                            value: String(catalog.id),
                                        },
                                    ],
                                }}
                            />
                        </CardCatalog>
                    ))}
                </NetworkStateNew>
            </LayoutCard>
        </PaginationLayout>
    );
};
